var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0173 5.33923H11.5181L11.5173 4.83843L11.5109 0.868426C11.5104 0.52364 11.8964 0.394364 12.1037 0.605232L18.5608 7.17485C18.7022 7.31868 18.7022 7.55618 18.5608 7.70001L12.1003 14.273C11.8932 14.4838 11.5076 14.3549 11.5076 14.0105V10.0356V9.53563H11.0076C10.7361 9.53563 10.4615 9.5318 10.187 9.52797C9.50289 9.51842 8.82047 9.50889 8.19455 9.55887C7.30266 9.63008 6.43415 9.82508 5.69409 10.3587C4.20088 11.4353 3.47044 13.6993 3.57674 18.0983C3.58176 18.306 3.47519 18.4054 3.40667 18.4334C3.37185 18.4476 3.34458 18.4463 3.32405 18.4395C3.30597 18.4335 3.26125 18.4128 3.21058 18.3308C2.31959 16.8892 1.61428 15.0802 1.40043 13.2571C1.18677 11.4355 1.46626 9.63468 2.49622 8.15628C3.44438 6.79528 5.09761 6.07596 6.807 5.70687C8.50448 5.34035 10.1616 5.33923 11.0173 5.33923Z",
    stroke: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.6960297ca81b7554193bfed8798f8b73.svg";
export { ForwardRef as ReactComponent };